import React from 'react'
import { Link } from 'react-router-dom'
import styles from './style.module.scss'

export const LoadingState = () => <div className={styles.state}>Loading handbook…</div>

export const ErrorState = ({ children }) => <div className={styles.stateError}>{children}</div>

export const Section = ({ title, hint, children }) => (
  <section className={styles.section}>
    {title && <h2 className={styles.sectionTitle}>{title}</h2>}
    {hint && <p className={styles.sectionHint}>{hint}</p>}
    {children}
  </section>
)

export const Steps = ({ items }) => (
  <ol className={styles.steps}>
    {items.map((item, index) => (
      <li className={styles.step} key={index}>
        <span className={styles.stepNum}>{index + 1}</span>
        <div className={styles.stepBody}>{item}</div>
      </li>
    ))}
  </ol>
)

export const Callout = ({ children, warn }) => (
  <div className={`${styles.callout} ${warn ? styles.calloutWarn : ''}`}>{children}</div>
)

export const TypeBadge = ({ type }) => {
  const key = `type${(type || 'string').charAt(0).toUpperCase()}${String(type || '').slice(1)}`
  return <span className={`${styles.badge} ${styles[key] || ''}`}>{type}</span>
}

export const FormBadge = ({ type }) => (
  <span className={`${styles.badge} ${type === 'Application' ? styles.badgeApplication : styles.badgeUpdate}`}>{type}</span>
)

export const TileLink = ({ to, title, badge, meta }) => (
  <Link className={styles.tile} to={to}>
    <span className={styles.tileName}>{title}</span>
    <span className={styles.tileMeta}>
      {badge}
      {meta}
    </span>
  </Link>
)
